import { Trans } from '@lingui/macro'
import { Trade } from '@uniswap/router-sdk'
import { Currency, TradeType } from '@uniswap/sdk-core'
import { ReactNode } from 'react'
import { Text } from 'rebass'

import { ButtonError } from '../Button'
import { AutoRow } from '../Row'
import { PayCallbackError } from './styleds'

export default function PayModalFooter({
  onConfirm,
  payErrorMessage,
  disabledConfirm,
}: {
  trade: Trade<Currency, Currency, TradeType>
  onConfirm: () => void
  payErrorMessage: ReactNode | undefined
  disabledConfirm: boolean
}) {
  return (
    <>
      <AutoRow>
        <ButtonError
          onClick={onConfirm}
          disabled={disabledConfirm}
          style={{ margin: '10px 0 0 0' }}
          id="confirm-pay-or-send"
        >
          <Text fontSize={20} fontWeight={500}>
            <Trans>Confirm Pay</Trans>
          </Text>
        </ButtonError>

        {payErrorMessage ? <PayCallbackError error={payErrorMessage} /> : null}
      </AutoRow>
    </>
  )
}
